import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { ConfirmationIcon } from '@wf-sl/common-icons'

import styles from './multi-step-bar.module.css'

const defaultProps = {
    activeStep: 0,
    classes: {},
    hideCaptions: false,
    steps: []
}

const propTypes = {
    activeStep: PropTypes.number,
    className: PropTypes.string,
    classes: PropTypes.shape({
        caption: PropTypes.string,
        figure: PropTypes.string,
        iconWrapper: PropTypes.string,
        progressElement: PropTypes.string
    }),
    hideCaptions: PropTypes.bool,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            caption: PropTypes.string,
            icon: PropTypes.element
        })
    )
}

function MultiStepBar({ activeStep, className, classes, hideCaptions, steps }) {
    const allClasses = {
        active: cx(styles['active'], 't3sel-multi-step-bar-step-active'),
        bar: cx(styles['bar'], className, 't3sel-multi-step-bar'),
        caption: cx(styles['caption'], classes.caption, 't3sel-multi-step-bar-step-caption'),
        completed: cx(styles['completed'], 't3sel-multi-step-bar-step-completed'),
        figure: cx(styles['figure'], 't3sel-multi-step-bar-step-figure', classes.figure),
        iconWrapper: cx(styles['icon-wrapper'], 't3sel-multi-step-bar-step-icon-wrapper', classes.iconWrapper),
        progressBar: cx(styles['progress-bar'], 't3sel-multi-step-progress-bar'),
        progressSection: cx(
            styles['progress-element'],
            hideCaptions && styles['progress-element-without-captions'],
            classes.progressElement,
            't3sel-multi-step-bar-progress-section'
        )
    }

    const percentage = Math.floor((activeStep / (steps.length - 1)) * 100) + '%'

    return (
        <figure className={allClasses.bar}>
            <section className={allClasses.progressSection}>
                {steps.map(({ caption, icon }, index) => {
                    const className = cx(allClasses.figure, {
                        [allClasses.active]: index === activeStep,
                        [allClasses.completed]: index < activeStep
                    })
                    const stepIcon =
                        index < activeStep ? (
                            <ConfirmationIcon className={styles['completed-icon']} />
                        ) : (
                            icon || <div className={allClasses.stepNumber}>{index + 1}</div>
                        )

                    return (
                        <figure key={index} className={className}>
                            <div className={allClasses.iconWrapper}>{stepIcon}</div>
                            {!hideCaptions && <figcaption className={allClasses.caption}>{caption}</figcaption>}
                        </figure>
                    )
                })}
                <div style={{ width: percentage }} className={allClasses.progressBar} />
            </section>
        </figure>
    )
}

MultiStepBar.defaultProps = defaultProps
MultiStepBar.propTypes = propTypes

export { MultiStepBar }
